import SimpleType from './simple-type';

class PaymentMethodType extends SimpleType {
  /* eslint-disable no-magic-numbers */
  static types = { 1: '納付書', 2: '口座振替／新規', 3: '口座振替／継続' };
  static isPaymentSlip = (typeCode) => typeCode && String(typeCode) === '1';
  static isDirectDebitNew = (typeCode) => typeCode && String(typeCode) === '2';
  static isDirectDebitContinue = (typeCode) => typeCode && String(typeCode) === '3';
  /* eslint-enable no-magic-numbers */
  isPaymentSlip () {
    const self = this;
    return PaymentMethodType.isPaymentSlip(self.getVal());
  }
  isDirectDebitNew () {
    const self = this;
    return PaymentMethodType.isDirectDebitNew(self.getVal());
  }
  isDirectDebitContinue () {
    const self = this;
    return PaymentMethodType.isDirectDebitContinue(self.getVal());
  }
  getTypes () {
    return PaymentMethodType.types;
  }
}
export default PaymentMethodType;
